import React from "react";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";

import { Dialog, DialogContent, DialogTitle } from "@fluid-app/ui";

import PlaylistWidget from "../playlist/PlaylistWidget";

interface StoryViewerModalProps {
  isOpen: boolean;
  onClose: () => void;
  isPlaylist?: boolean;
  containerRoot?: ShadowRoot | Element;
}

const StoryViewerModal: React.FC<StoryViewerModalProps> = ({
  isOpen,
  onClose,
  isPlaylist = true,
  containerRoot,
}) => (
  <Dialog open={isOpen} onOpenChange={onClose}>
    <VisuallyHidden>
      <DialogTitle>Dialog Title Here</DialogTitle>
    </VisuallyHidden>
    <DialogContent
      className="m-0 h-full w-full max-w-none overflow-x-auto border-0 bg-transparent p-0 text-white"
      closeButtonPosition="left"
      containerRoot={containerRoot}
    >
      <PlaylistWidget isPlaylist={isPlaylist} />
    </DialogContent>
  </Dialog>
);

export default StoryViewerModal;
